const config = {
  BACKEND_URL: 'https://scribespace-backend.onrender.com',
  GITHUB_CALLBACK_URL: 'https://scribespace-backend.onrender.com/api/auth/github/callback'
};

export default config; 